export const meta = { id: 'O27', slug: 'componentes-praticos', title: 'Como usar Componentes práticos', description: 'Use atividades, casos, role plays, Evidências e checkpoints para complementar o aprendizado.', profile: 'owner', category: 'formacoes', type: 'concept', status: 'published', order: 570, keywords: ['atividade prática','estudo de caso','role play','evidência','checkpoint'], previous: 'O26', next: 'O28', related: ['O25','A11'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como usar Componentes práticos

Nem todo desenvolvimento acontece consumindo conteúdo. Componentes práticos ajudam o participante a aplicar, demonstrar e verificar o que desenvolveu.

## Exemplos de uso

- **Atividade prática:** executar algo no contexto real;
- **Estudo de caso:** analisar uma situação e tomar decisões;
- **Role play:** praticar uma interação ou comportamento;
- **Evidência:** demonstrar aplicação ou resultado;
- **Checkpoint:** verificar uma condição ou marco do percurso.

<Callout type="concept">Na lógica CHA, esses componentes ajudam a transformar Conhecimento em Habilidade e Atitude observáveis.</Callout>
